import React, { useEffect, useState } from "react";
import classes from "./Layout.module.css";

const Layout = ({ children }) => {
    return (
        <div className={classes.game_overlay}>
            <div className={classes.game_container}>
                <div className={classes.game}>
                    {children}
                </div>
            </div>
        </div>
    )
};
export default Layout;